import JwtService from '@/api/jwt.service';

export const getAuthConfig = () => {
  return {
    username: JwtService.getToken()
  };
};
